import {homeCn} from './home/homeCn.js';
import {memberCn} from './member/memberCn.js';
export const message = {
  language: '中文-English',
  noData: '暂无数据',
  reset: '清空',
  more: '更多',
  keshi: '课时',
  jinping: '精品',
  zixuncishu: '咨询次数：',
  pingfeng: '评分：',
  pingfeng1: '评分',
  day: '天',
  zjjs: '专家介绍',
  qxzzxlx: '请选择咨询类型',
  goumaizixun: '购买咨询',
  chankanxiangqing: '查看详情',
  join: '加入清单',
  time: '次',
  lijizixun: '立即咨询',
  cankaojia: '参考价：',
  lijixiadan: '立即下单',
  num: '数量',
  close: '取消',
  baocun: '保存',
  jian: '件',
  //订单
  mianfei: '免费',
  shoufei: '收费',
  xianmian: '限免',
  leijipingjia: '累计评价',
  zhixunjiage: '咨询价格',
  zhixunshichange: '咨询时长',
  dingdanxinxi: '订单信息',
  yingfuzongjia: '应付总价',
  youhuijine: '优惠金额',
  fuwuzongjine: '服务总金额',
  fuwu: '项服务',
  yixuanze: '已选择',
  ddhjhyf: '订单合计（含运费）',
  xuanzefuwu: '选择服务',
  shangpingxinxi: '商品信息',
  fuwuxinxi: '服务信息',
  jibenxinxi: '基本信息',
  dingdanhao: '订单号',
  xiadanshijian: '下单时间',
  dingdanzonge: '订单总额',
  dingdanleixing: '订单类型',
  dingdanzhuangtai: '订单状态',
  zhuangjiaxinxi: '专家信息',
  jiage: '价格',
  danjia: '单价',
  zongji: '总计',
  zhifuxinxi: '支付信息',
  zhifuContent: '订单已提交，请在 48 小时内完成支付！逾期订单将被取消。',
  fukuanfangshi: '付款方式',
  fukuanshijian: '付款时间',
  youhuiquan: '优惠券',
  fuwuyouhui: '服务优惠',
  yingfujine: '应付金额',
  dingdanyouhui: '订单优惠',
  dingdanliuyan: '订单留言',
  shuruliuyan: '输入留言',
  fahuoshijian: '发货时间',
  guojia: '国家',
  sheng: '省',
  shi: '市',
  qu: '区',
  xian: '县',
  xiangxidizhi: '详细地址',
  shangchuan: '上传',
  tianjiafujian: '添加附件',
  tijiao: '提交',
  tijiaodingdan: '提交订单',
  readAndAgree: '我已阅读并同意',
  sousuo: '检索',
  quanbu: '全部',
  xiaoliang: '销量',
  an: '默认',
  riqi: '日期',
  wePay: '微信支付',
  aliPay: '支付宝支付',
  yinlianPay: '银联在线支付',
  paypalPay: 'PayPal支付',
  xianxiaPay: '线下支付',
  payContent: '支付即同意《中国贸促会中小服务平台-用户协议》',
  zhanghumingcheng: '账户名称：',
  shoukuanzhanghao: '收款账号：',
  kaifuyinghang: '开户银行：',
  beizhu: '备注：',
  beizhuplaceholder: '请输入备注',
  fhgmjl: '返回购买记录',
  shangchuanpingzheng: '上传凭证：',
  sfzzmsc: '身份证正面上传',
  sfzfmsc: '身份证反面上传',
  baocuncaogao: '保存草稿',
  xiayibu: '下一步',
  tishi: '提示',
  queren: '确认',
  tianjiashdz: '添加收货地址',
  tianjiafp: '添加发票',
  bianjifp: '编辑发票',
  zhifu: '支付',
  zhifufq: '支付分期',
  quxiaodingdan: '取消订单',
  huiyuanquanxian: '会员权限',
  shangchuantupian: '上传图片',
  zhonghepingjia: '综合评价',
  chucipinglun: '初次评论',
  zuijiapinglun: '追加评论',
  pingtaihuifu: '平台回复',
  quxiaozhifu: '取消支付',
  qzlfznwczf: '请在两分钟内完成支付',
  qishu: '期数',
  quanxuan: '全选',
  cpxx: '产品信息',
  jineo: '金额',
  chaozuo: '操作',
  shixiao: '失效',
  shanchu: '删除',
  jiancheqingdangNull: '检测清单空空的哦~，去看看心仪的商品吧~',
  qucaihou: '去采购',
  baocunjcfa: '保存检测方案',
  fanganmingcheng: '方案名称',
  goumaishuliang: '购买数量：',
  lijigoumai: '立即购买',
  fuwuxiangqing: '服务详情',
  fuwupinglun: '服务评论',
  anmoren: '按默认',
  shijiandaoxu: '时间倒序',
  shijiansunxu: '时间顺序',
  edit: '编辑',
  qingshurnxgxx: '请输入相关信息',
  baocuncg: '保存成功',
  baocunshibai: '保存失败',
  shanchushibai: '删除成功',
  shengyu: '剩余',
  yidaoqi: '已到期',
  chakan: '查看',
  chongxinsq: '重新申请',
  yishixiao: '已生效',
  weishixiao: '未生效',
  taochandd: '套餐订单',
  biaozhuidd: '标准订单',
  return: '返回',
  yishix: '已失效',
  lingqu: '领取',
  zhifudingdan: '支付订单',
  mashangxiadan: '马上下单',
  shousuo: '搜索',
  xiugai: '修改',
  shezhimr: '设为默认',
  qingxuanzhe: '请选择',
  sjhmbnwk: '手机号码不能为空',
  qsrzqdsjhm: '请输入正确的手机号码',
  qsrsf: '请输入省份',
  qsrttmc: '请输抬头名称',
  qsrxxdz: '请输入详细地址',
  qsrnsrxbh: '请输入纳税人识别号',
  qsrsssfsz: '请输入所属省份市镇',
  qingshurngjz: '请输入关键字',
  weibangding: '未绑定',
  shuaxin: '刷新',
  qsywxsmewm: '请使用微信扫描二维码',
  shaoyishaobd: '扫一扫绑定',
  shifouqrjbwx: '是否确定解绑微信？',
  bianji: '编缉',
  huiyuanmzbnwk: '会员姓名不能为空！',
  qingtianxnidxb: '请填写您的性别！',
  juzdbunwk: '居住地不能为空！',
  xxddbnwk: '详细地址不能为空！',
  qsrzqdyx: '请输入正确的邮箱！',
  tishengczz: '提升成长值',
  chengzhongzhi: '成长值',
  manzu: '满足',
  goumai: '购买',
  yigoumai: '已购买',
  mctpxfwlbjb: '贸促通平台服务列表/级别',
  ffhyfwnrhydj: '付费会员服务内容/会员等级',
  jinxingzhong: '进行中',
  yijieshu: '已结束',
  shengyuzxsj: '剩余咨询时间：',
  wodepingjia: '我的评价',
  wodezhuiping: '我的追评',
  zhuiping: '追评',
  fenxaingxinqing: '分享体验心得，给万千想买的人一个参考！',
  pingjiazhishuyaoqiu: '评价不少于10个字',
  tijiaopingjia: '提交评价',
  fuwupingjiayiwc: '服务评价已完成',
  fanhuidaipingjiaList: '返回待评价列表',
  pingjiasaidan: '评价晒单',
  fanganbianhao: '方案编号',
  baocunshijian: '保存时间',
  shouqi: '收起',
  zhuankai: '展开',
  fananxinximc: '方案服务信息',
  xiugaifanganmc: '修改方案名称',
  peixunfuwupingjiayiwc: '培训服务评价已完成',
  zhifeichengzhuangzhi: '积分+5、成长值+10',
  peixunfuwuzhuijiapj: '培训订单追加评价',
  peixundingdanpj: '培训订单评价',
  jie: '节',
  zhuijiapingjia: '追加评价',
  lijipingjia: '立即评价',
  lijizifu: '立即支付',
  pingtaiyouhuiquan: '平台优惠券',
  youhuiquanduihuanma: '优惠券兑换码',
  hqPayPalsb: '获取PayPal支付失败',
  hqzfhsb: '获取支付号失败',
  wjscxz: '当前限制选择1个文件',
  wenjianscsb: '文件上传失败',
  qingscpz: '请上传凭证',
  qydbtyyhxy: '请阅读并同意用户协议！',
  qwcftjdd: '请勿重复提交订单',
  gddysxqcxxd: '该订单已生效，请重新下单',
  tupian: '图片',
  haoping: '好评',
  zhongping: '中评',
  chaping: '差评',
  zhuijia: '追加',
  gspzwmjpl: '该商品暂无买家评论哦~',
  kecengxixi: '课程信息',
  xuanzetaocan: '选择套餐',
  zhuanjiamingc: '专家名称',
  zhuanjiazxts: '专家咨询天数',
  zwglxdpxfwjqdd: '暂无该类型的培训服务，敬请期待！',
  wanzhengsp: '完整视频',
  di: '第',
  kecheng: '课程',
  kaitongsc: '开通时长',
  geyue: '个月',
  cpmc: '产品名称',
  heji: '合计',
  cpbz: '产品备注',
  sqrxx: '申请人信息',
  tjddsrrbz: '请用中文实名填写，首次提交订单时填写的申请人信息将存入您的账号信息，同时会用于订单申请表。保存后将无法直接修改，如有疑问，请联系在线客服。',
  xingming: '姓名：',
  qsrxingming: '请输入名字',
  qsrlxdh: '请输入联系电话',
  dzyx: '电子邮箱：',
  qingsrdzyx: '请输入电子邮箱',
  qiyexinxibz: '请准确填写，首次提交订单时填写的企业信息将存入您的账户信息，同时会用于订单申请表。保存后将无法直接修改，如有疑问，请联系在线客服',
  qsrgsmc: '请输入公司名称',
  yangpingcl: '样品处理',
  feiqicl: '废弃处理',
  yuanyangjihui: '原样寄回',
  yuanyangjhsyf: '如需寄回原样，则另计邮费',
  mctcpjcrzptxy: '《贸促通产品检测认证平台协议》',
  shangchuancg: '上传成功',
  shangchuansb: '上传失败',
  yicgtcdl: '已成功退出登录',
  huoquylzfsb: '获取银联支付失败',
  dakaiylzfsb: '打开银联支付失败',
  shouchaungcg: '收藏成功',
  xianxiazfcg: '线下支付成功',
  zhifusb: '支付失败',
  zhifucg: '支付成功',
  qtxndzxnr: '请填写您的咨询内容',
  qingtxxm: '请填写姓名',
  qingtxsjhm: '请填写手机号码',
  qingtxyx: '请填写邮箱',
  tingtxqymc: '请填写企业名称',
  qingtxfwsmc: '请填写服务商名称',
  qingxzs: '请选择省',
  qingxzshi: '请选择市',
  qingxzxq: '请选择县/区',
  qingxzfwlx: '请选择服务类型',
  qingxuanzhefw: '请选择服务！',
  qingshurnzxry: '请输入咨询内容！',
  qingshurnxm: '请输入姓名！',
  qingshurnsjhm: '请输入手机号码！',
  qingshurnyx: '请输入邮箱！',
  qingxuanzhesf: '请选择省份！',
  qingxuanzecs: '请选择城市！',
  qingxuanzedq: '请选择地区！',
  qingxuanzeqymc: '请输入企业名称！',
  qingshurnzdfwsbj: '请输入指定服务商报价！',
  qingyuedubtyxy: '请阅读并同意协议！',
  gaifeileiwbdjcx: '该分类未绑定检测项',
  qingzsxzyx: '请至少选择一项',
  qinggouxbtx: '请勾选必选项',
  renzhenfwsccg: '认证服务删除成功',
  qingxaunzegmfw: '请选择购买服务',
  qingxuanzegnmfamc: '请输入购买方案名称',
  gaifuwuyxj: '该服务已下架！',
  wuxaiosp: '无效商品！',
  gaifuwuysx: '该服务已失效！',
  qingxaunzewzdgg: '请选择完整的规格',
  qingshurndwmc: '请输入单位名称',
  qingshurnsprxm: '请输入收票人姓名',
  qingshurnsprsf: '请选择收票人省份',
  qingshurnzqdlxdh: '请输入正确的联系电话',
  qingshurnzqddzyx: '请输入正确的电子邮箱',
  qingydxybty: '请阅读协议并同意！',
  qingwucwtj: '请勿重复提交！',
  qingshurnttmc: '请输入抬头名称',
  qingshurnsprsj: '请输入收票人手机',
  qingshurnzqsprsj: '请输入正确收票人手机',
  qingshurnzqspryx: '请输入正确收票人邮箱',
  guojiahuoqusibai: '国家获取失败',
  fenleihqsb: '分类获取失败',
  liebiaohqsb: '列表获取失败',
  youxiangbnwk: '邮箱不能为空',
  qingshurnzhensxm: '请输入真实姓名',
  scgs: '上传图片只能是 JPG 和 PNG 格式!',
  scxzdx: '上传图片大小不能超过 2MB!',
  qscsfzzmz: '请上传身份证正面照',
  qscsfzfmz: '请上传身份证反面照',
  qscyjzzsmj: '请上传营业执照扫描件',
  qscqyzzzssmj: '企业资质证书扫描件',
  qscjjclhptzczh: '请上传简介材料或平台注册账号经办人授权书',
  qsrzjjj: '请输入专家简介',
  qsczjzzzssmj: '请上传专家资质证书扫描件',
  qsczjgrlw: '请上传专家个人论文',
  tijiaosb: '提交失败',
  qscgajgczdzwbljlsmwj: '请上传公安机关出证的暂无不良记录扫描文件',
  yishouc: '已收藏',
  nian: '年',
  qxzzjfl: '请输入专家分类！',
  qxzzjszgj: '请选择专家所在国家！',
  qxzzjsyxxdz: '请选择专家所在详细地址！',
  qxzzznx: '请选择资质年限！',
  qxzhyfw: '请选择行业服务',
  qxzscqy: '请选择擅长区域！',
  qsczzzssnj: '请上传资质证书扫描件！',
  qscgrlwfj: '请上传个人论文附件！',
  qsrjygzjl: '请输入教育工作经历！',
  baocuncaogaocg: '保存草稿成功',
  qsrnrhscwj: '请输入内容或上传文件',
  gaizjyxj: '该专家已下架',
  pxlbhqsb: '培训列表获取失败',
  qsrzmbhmc: '请输入证书编号/名称',
  zscxcg: '证书查询成功',
  zscxsb: '证书查询失败',
  quxiaoddcg: '取消订单成功',
  qingsctp: '请上传图片',
  tupianscxz: '图片最多只能上传5张',
  qingwucfdj: '请勿重复点击',
  qingsrswzf: '请输入10位字符',
  pingluncg: '评论成功',
  pinglunsb: '评论失败',
  zhuipingsb: '追评失败',
  gaifufuyisixiao: '该服务已经失效',
  huoquewmsb: '获取二维码失败，请刷新',
  bangdingcg: '绑定成功',
  gaiwxybdqtzh: '该微信已绑定其它账号！',
  bangdingsb: '绑定失败',
  qcxhqewm: '请重新获取二维码',
  jiebangcg: '解绑成功',
  jiebangsb: '解绑失败',
  yangpingjisong: '样品寄送',
  fenqizifu: '支付分期',
  hengye: '行业',
  fuwuleimu: '服务类目',
  fuwussss: '服务',
  qingsrfhr: '请输入发货人',
  qingsrlxfs: '请输入联系方式',
  qingxuanzewllx: '请选择物流类型',
  qsrwlbh: '请输入物流编号',
  qsrypmc: '请输入样品名称',
  qsrypsl: '请输入样品数量',
  qsrfhrmc: '请输入发货人名称',
  qsrfhrsj: '请输入发货人手机',
  qxzfhrsf: '请选择发货人省份！',
  qxzfhrcs: '请选择发货人城市！',
  qxzfhrdq: '请选择发货人地区！',
  qxzfhrxxdz: '请输入发货人详细地址！',
  qxzshrmc: '请输入收货人名称',
  qsrshrsj: '请输入收货人手机！',
  qxzshrsf: '请选择收货人省份！',
  qxzshrcs: '请选择收货人城市！',
  qxzshrdq: '请输入收货人地区！',
  qxzshrxxdz: '请输入收货人详细地址！',
  qxzypclfs: '请选择样品处理方式',
  gfwzwjcfw: '该服务暂无检测服务',
  zszwscqnxdd: '证书暂未生成，请耐心等待',
  wuliugenzhongztxx: '物流跟踪状态信息',
  querenshouhuo: '确认收货',
  chakanwuliu: '查看物流',
  xuyaojihui: '需要寄回',
  buxuyaojihui: '不需要寄回',
  qtxplnr: '请填写评价内容',
  zhuipingcg: '追评成功',
  tupianscsb: '图片上传失败',
  qxzxyscdsj: '请选择需要删除的数据',
  gaidingdanyisc: '该订单已生成申请表，请到会员中心-订单列表进行支付!',
  qingshurn: '请输入',
  qingshurnrzjggs: '请输入认证机构/公司',
  qingshurntyjgdmz: '请输入统一机构代码证',
  qingshurnjcjghm: '请输入手机号码',
  qingxzgj: '请选择国家',
  qingxzjcrzfwxm: '请选择检测认证服务项目',
  qingxzjcrxzgj: '请选择检测认证服务国家',
  qingtxgsjj: '请填写公司简介',
  qingxzssq: '请选择省市区',
  qingtxqyszd: '请填写企业所在地',
  qingscsmjyizl: '请上传扫描件以及资料',
  qingtxbtx: '请填写必填项',
  jingkcygm: '仅课程已经购买',
  jingkc: '仅课程',
  qingxzkthytc: '请选择开通会员套餐',
  xuanzezhmmfs: '选择找回密码方式：',
  bangdingyx: '绑定邮箱：',
  qingshurnybdyx: '请输入已绑定邮箱',
  tgbdyxzhzhmm: '通过绑定邮箱账号找回密码',
  tgbdsjhmzhmm: '通过绑定手机号码找回密码',
  qxzzhmmdfs: '请选择找回密码的方式',
  qsrbdyx: '请输入绑定邮箱',
  sryzmywhzhyw: '发送验证码失败。或账号有误。',
  yanzhengmacuowu: '验证码错误！',
  yzyxysd: '验证邮件已送达',
  qdlyxdj: '请登录邮箱，点击激活链接完成密码找回，激活链接在30分钟内有效',
  qcsyj: '请查收邮件',
  qzxqwyxcsyj: '请自行前往邮箱查收邮件',
  yjyfsbycfdj: '邮件已发送，不要重复点击',
  fasongyjsb: '发送邮件失败',
  xiugaidlmm: '修改登录密码：',
  denglummqr: '登录密码确认：',
  zcsrmm: '请再次输入密码',
  shezhimima: '设置密码',
  mimagsbudui: '密码至少为数字、字母、字符结合的8位数(!@#$%^&*_. 字符只能是这些)',
  liangcimmbyz: '两次输入密码不一致',
  xiugaisibai: '修改失败',
  nycgxgmctdlmm: '您已成功修改贸促通产品检测认证平台的登录密码！',
  msdlbfhsy: '马上登录并返回首页',
  tongguoyanz: '通过验证',
  nyjtgyxyz: '您已成功通过邮箱验证！',
  youxiangyzsb: '邮箱验证失败！',
  yanzhengzhxx: '验证账号信息',
  mmxgcg: '密码修改成功',
  xiugaidlmm1: '修改登录密码',
  huiyuandenglu: '会员登录',
  zhuanghu: '账户',
  qsrzhm: '请输入账户名',
  mima: '密码',
  qingsrmima: '请输入密码',
  dlmhmmcw: '账号名或密码错误',
  denglu: '登录',
  baocundlxx: '保存登录信息',
  wangjimima: '忘记密码',
  wancptyz: '完成拼图验证',
  huanyizheng: '换一张',
  shaoyisaodl: '扫一扫登录',
  zhmmdl: '账号密码登录',
  shaomadlcg: '扫码成功,初次登陆，请使用密码登陆绑定微信',
  qingsrzh: '请输入账号',
  yanzhengsb: '验证失败！',
  shaoyisaozc: '扫一扫快捷注册',
  shoujizc: '手机注册',
  youxiangzc: '邮箱注册',
  nicheng: '昵称',
  qsrndnc: '请输入您的昵称',
  zaicishurnmima: '再次输入密码',
  zucezg: '恭喜您！您已成功注册为贸促通产品检测认证平台会员！ 使用中如遇到任何问题，请及时联系平台客服！',
  dengluzh: '登录账户',
  lijidenglu: '立即登录',
  wxsmzcdl: '微信扫码注册账号',
  txxxbszmm: '填写信息并设置密码',
  zhucecg: '注册成功',
  qingshurnndyxzh: '请输入您的邮箱账号',
  xieyi: '《贸促通产品检测认证平台注册协议》',
  weixizuce: '微信注册',
  lainjiyouxiaoqi: '请登录邮箱，点击激活链接完成邮箱注册，激活链接在24小时内有效',
  meiyoushpooudao: '没有收到邮件？',
  mmylwszzc: '密码由6位数字组成',
  qingsryzm: '请输入验证码！',
  qingsrzqdyzm: '请输入正确的验证码！',
  yzmyfsqdlyxck: '验证码已发送，请登录邮箱查看！',
  gaiyouxiangyzc: '该邮箱已注册！',
  mimazuc: '密码由6-16位数字组成！',
  qingshurunc: '请输入昵称',
  yifasongyzm: '已发送验证码',
  gaizhyzc: '该账号已注册！',
  fenqifukuan: '分期付款：',
  juliczzkong: '距离下一个等级还要',
  juliczzzhi: '成长值',
  changzhengzhimingxi: '成长值明细',
  xingwei: '行为',
  pingjia: '评价',
  changzhengzhibianhua: '成长值变化',
  xiaofei: '消费',
  qxzhydj: '请选择会员等级',
  goumaihuiyuan: '购买会员',
  baogaoxinshi: '报告形式：',
  huiyuandengji: '会员等级：',
  huiyuanjiage: '会员价格：',
  tishengfuwuxiangmu: '提升服务项目',
  kaitongviphuiyuan: '开通VIP会员',
  gxntjddcg: '恭喜您，订单提交成功！',
  ljqwddlbtxsqb: '立即前往订单列表,填写申请表',
  caozuochenggong: '操作成功',
  ryywqlxptcxbj: '如果有疑问请联系平台',
  zjzxpj: '专家咨询评价',
  zjzxpjywc: '专家评价已完成',
  zfjzjj: '咨询时长工：',
  xiaoshi: '小时',
  zhuanjiashuiping: '专家水平：',
  huifuziliang: '回复质量：',
  huifusudu: '回复速度：',

  //首页
  ...homeCn,
  // member里的路由
  ...memberCn,
  // 顶部
  topNav: {
    login: '您好，请登录！',
    register: '立即注册',
    join: '加入我们',
    member: {
      text: '会员中心',
      perMember: '个人中心',
      woOrder: '我的订单',
      busMember: '业务中心',
    },
    understand: '了解贸促通',
    guide: '操作指南',
    gadget: {
      text: '小工具',
    },
    Hello: '你好',
    signOut: '退出',
  },
  // 导航栏
  menu: {
    home: '首页',
    zaxianzhixun: '在线咨询',
    kefurexian: '客服热线',
    guanzhugongzonghao: '关注公众号',
    fanhuidingbu: '返回顶部',
    jiancheqingdang: '检测清单',
    lijikszx: '立即开始咨询',
    yzyrygtkhfw: '与专业人员沟通客户服务解决方案',
    qgkfrexian: '全国客服热线',
    meirizhixun: '每日资讯',
    zaixianxiadang: '在线下单',
    policy: '政策宣导',
    meiyouzh: '没有账号',
    mashangzc: '马上注册',
    yiyouzh: '已有账号',
    mashangdl: '马上登录',
    verify: {
      text: '商事认证',
      child: {
        a: '原地产证',
        b: '商事证明',
        c: 'ATA单证册',
        d: '领事认证',
        e: '自由销售证明书',
        f: '中国出口品牌证明书',
      },
    },
    legal: {
      text: '法律服务',
      child: {
        a: '商事调解',
        b: '仲裁服务',
        c: '法律综合服务',
      },
    },
    foreign: {
      text: '外贸服务',
      child: {
        a: '1039服务',
        b: '通关服务',
        c: '仓储服务',
        d: '物流服务',
      },
    },
    knowledge: {
      text: '知识产权',
      child: {
        a: '商标',
        b: '专利',
      },
    },
    testing: {
      text: '检测认证',
      child: {
        a: '首页',
        b: '资料库',
        c: '培训服务',
        d: '专家中心',
        e: '代理渠道',
      },
    },
    comprehensive: {
      text: '贸易与供应链金融',
      child: {
        a: '供应链代采服务',
        b: '应收账款融资服务',
        c: '预付款融资服务',
        d: '库存质押融资服务',
      },
    },
    about: {
      text: '关于我们',
      child: {
        a: '贸推中心简介',
        b: '领导致辞',
        c: '联系方式',
        d: '招聘信息',
        e: '关于贸促通',
      },
    },
  },
  // 个人中心-左侧导航栏
  memberNav: {
    testing: {
      text: '检测认证',
      home: '首页',
      order: '订单',
      inquiry: '询价单',
      plan: '检测方案',
      evaluate: '订单评价',
    },
    train: {
      text: '培训服务',
      course: '已购课程',
      order: '培训订单',
      evaluate: '课程评价',
    },
    consult: {
      text: '专家咨询',
      myConsult: '我的咨询',
      order: '购买记录',
      evaluate: '咨询评价',
    },
    account: {
      text: '账户服务',
      info: '会员信息',
      collect: '会员收藏',
      integral: '积分管理',
      coupon: '我的优惠劵',
      certificate: '证书管理',
      specimen: '样品管理',
      record: '浏览记录',
      docking: '客服对接',
      address: '地址簿',
      invoice: '发票信息',
      afterSaleList: '售后服务列表',
      afterSaleSev: '售后管理',
      grade: '会员等级',
      userpass: '用户密码修改',
    },
  },
  // 底部
  footer: {
    top: {
      // CCPIT: '中国国际贸易促进委员会',
      service: '中国贸促会商事服务网',
      office: '中国贸促会专利商标事务所',
      lvhui: '律回—国际商事法律服务平台',
    },
    about: {
      text: '关于我们',
      understand: '了解贸促通',
    },
    commercial: {
      text: '商事认证',
      origin: '原地产证',
      certificate: '商事证明',
      carnets: 'ATA单证册',
      consular: '领事认证',
      freeSale: '自由销售证明书',
      exportBrand: '中国出口品牌证明书',
    },
    testing: {
      text: '检测认证',
      electromechanical: '机电',
      textile: '纺织服装',
      medical: '食品医疗',
      other: '其他类',
    },
    Legal: {
      text: '法律服务',
      conciliation: '商事调解',
      arbitration: '仲裁服务',
      comprehensive: '法律综合服务',
    },
    foreign: {
      text: '外贸服务',
      service: '1039服务',
      clearance: '通关服务',
      storage: '仓储服务',
      logistics: '物流服务',
    },
    property: {
      text: '知识产权',
      trademark: '商标',
      patent: '专利',
    },
    comprehensive: {
      text: '贸易与供应链金融',
      agency: '供应链代采服务',
      b: '应收账款融资服务',
      c: '预付款融资服务',
      d: '库存质押融资服务',
    },
    foot: {
      // development: '中国国际贸易促进委员会贸易推广交流中心',
      // council: '中国贸促会（广东）自由贸易试验区南沙服务中心',
      copyright: '版权所有   ©中贸科技（广州）有限公司',
      // NanSha: '南沙办公地点:广州市南沙区金茂湾创新大厦1101-1106',
      location: '办公地点:广州市天河区天盈广场西塔30楼',
      national: '全国客服热线：400-008-0170',
    },
  },
  //ZSteps组件
  zsteps: {
    tianxiezhm: '填写账户名',
    yanzhengshenfen: '验证身份',
    shezhixinmima: '设置新密码',
    wancheng: '完成',
    tianxiezxxx: '填写咨询信息',
    tijiaocg: '提交成功',
    tijiaodd: '提交订单',
    tianxiesqb: '填写申请表',
    zhifu: '支付',
    fwwuzhong: '服务中',
    xiazaibaogao: '下载报告/评价',
    tianxieruzzl: '填写入驻资料',
    pingtaishenhe: '平台审核',
    ruzhucg: '入驻成功',
    dingdanjiaoyiwc: '订单交易完成',
  },
  MyCoupons: {
    wdyhq: '我的优惠券',
    youxiaoqkssj: '有效期开始时间',
    kssj: '开始时间',
    jssj: '结束时间',
    youxiaoqjssj: '有效期结束时间',
    youhuiquanleixing: '优惠券类型',
    youhuiquanmc: '优惠券名称',
    qingshuruyouhuiquanmc: '请输入优惠券名称',
    quanbuyouhuiquan: '全部优惠券',
    weishiyong: '未使用',
    yishiyong: '已使用',
    yiguoqi: '已过期',
    lingquyouhuiquan: '领取优惠券',
    ahznwuxgyhq: '暂无相关的优惠券',
    qianwanglq: '前往领取',
    man: '满',
    keyong: '可用',
    xianpinglei: '限品类',
    xianpingtai: '限平台',
    quanbianhao: '券编号',
    weiqiyongf: '未启用',
    lijishiyong: '立即使用',
    tongyongyouhuiquan: '通用优惠券',
    fuyouhuiquan: '服务优惠券',
    pxfwyouhuiquan: '培训视频优惠券',
    zxzjyouhuiquan: '咨询专家优惠券',
    quanbufw: '全部服务',
    zhidingfenlei: '指定分类',
    zhidingsp: '指定商品',
  },
  //状态
  status: {
    daizhifu: '待支付',
    daicaishen: '待财审',
    yizhifu: '已支付',
    yiwancheng: '已完成',
    yipingjia: '已评价',
    yizuiping: '已追评',
    yiquxiao: '已取消',
    zhifubao: '支付宝',
    weixinzf: '微信支付',
    yinglian: '银联',
    xianxiazf: '线下支付',
    paypalzf: 'paypal支付',
    xcxzf: '小程序支付',
    xcxxxzf: '小程序线下支付',
    zhuce: '注册',
    fuwudingdan: '服务订单',
    fwddpj: '服务订单评价',
    zhuanjiadingdan: '专家订单',
    zjddpj: '专家订单评价',
    peixunfuwudingdan: '培训服务订单',
    pxfwddpj: '培训服务订单评价',
    kthydd: '开通会员订单',
    dmyhq: '兑换优惠券',
    shenghe: '审核中',
    fwwuzhong: '服务中',
    baojiazhong: '报价中',
    yibaojia: '已报价',
    yixiadan: '已下单',
    daifukuan: '待付款',
    jiaoyiguanbi: '交易关闭',
    zhixunzhong: '咨询中',
    shenqingdingdan: '申请订单',
    daishenghe: '待审核',
    daitianxsqb: '待填写申请表',
    caishencg: '财审成功',
    caishrenbh: '财审驳回',
  },
};



// WEBPACK FOOTER //
// ./src/lang/zh.js